<template>
  <footer v-if="!isStc" class="grow-0 text-[#999999] text-[10px] flex justify-between mx-[14px] my-2">
    <div>Powered by Scantrust</div>
    <div>v.{{version}}</div>
  </footer>
</template>

<script setup>
defineProps({
  isStc: Boolean,
  version: String
})
</script>